module.exports = __webpack_public_path__ + "img/comission on children logo.bfa01555.jpg";